import { render, staticRenderFns } from "./user-resend-activation.component.vue?vue&type=template&id=60c6ac1c&scoped=true&"
import script from "./user-resend-activation.component.ts?vue&type=script&lang=ts&"
export * from "./user-resend-activation.component.ts?vue&type=script&lang=ts&"
import style0 from "./user-resend-activation.component.scss?vue&type=style&index=0&id=60c6ac1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c6ac1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
